import { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import { Navigate } from "react-router-dom";

export default function Login() {
  const auth = useAuth();

  useEffect(() => {
    if (!auth.isAuthenticated && !auth.isLoading && !auth.activeNavigator) {
      // No active flow — show the sign-in button
    }
  }, [auth]);

  if (auth.isAuthenticated) return <Navigate to="/" replace />;

  return (
    <div className="flex min-h-screen items-center justify-center bg-ink-50 px-6">
      <div className="card w-full max-w-md p-10">
        <div className="mb-8">
          <h1 className="text-2xl font-semibold tracking-tight">
            Accuryn Sales
          </h1>
          <p className="mt-2 text-sm text-ink-500">
            Sign in with your @accuryn.com account.
          </p>
        </div>
        <button
          type="button"
          className="btn-primary w-full"
          disabled={auth.isLoading}
          onClick={() => auth.signinRedirect()}
        >
          {auth.isLoading ? "Loading…" : "Sign in"}
        </button>
        {auth.error && (
          <p className="mt-4 text-sm text-danger">{auth.error.message}</p>
        )}
      </div>
    </div>
  );
}
